import { PropsWithChildren } from 'react'
import { NavLink } from 'react-router-dom'
import { Box, Button, Typography, styled } from '@mui/material'
import { OrderBySellerProps } from '../../types/tracking'
import { formatDate } from '../../utils/format'
import { orderNumber } from '../../utils/utilities'
import DEFAULT from '../../config/default'

import { 
    Step2AsStatus3Icon

} from '../../assets'

const OrderList = ({ children }: PropsWithChildren) => {
    return (
        <OrderListRoot>
            {children}
        </OrderListRoot>
    )
}

const OrderListRoot = styled(Box)(({ theme }) => ({
    '& > div:not(:last-child)': {
        marginBottom: theme.spacing(2)
    }
}))

interface OrderListItemProps {
    data: OrderBySellerProps
}

const OrderListItem = ({ data }: OrderListItemProps) => {
    return (
        <OrderListItemRoot>
            <OrderListItemDate>
                <ItemDateNumber>{formatDate(data.fecha, 'DD')}</ItemDateNumber>
                <ItemDateMonth>{formatDate(data.fecha, 'MMM')}</ItemDateMonth>
            </OrderListItemDate>
            <OrderListItemData>
                <OrderListItemDataGroupStyled>
                    <OrderListItemDataGroupAStyled>
                        <Typography variant="body2" color="primary" lineHeight="1">
                            Pedido {orderNumber(data)}
                        </Typography>
                    </OrderListItemDataGroupAStyled>
                    {data.ciclo !== undefined && data.ciclo && DEFAULT.api.countryCode === 'CO' && (
                        <OrderListItemDataGroupAStyled>
                            <Typography variant="body2" color="primary" lineHeight="1">
                                Ciclo {data.ciclo}
                            </Typography>
                        </OrderListItemDataGroupAStyled>
                    )}
                    <OrderListItemDataGroupAStyled>
                        <Typography variant="body2" lineHeight="1" color="textSecondary">
                            {formatDate(data.fechaEvento)}
                        </Typography>
                    </OrderListItemDataGroupAStyled>
                    <OrderListItemDataGroupAStyled>
                        <Typography variant="body2" color="primary" lineHeight="1" fontWeight={500}>
                            {data.nombreVisualizacionConsultoraEvento}
                        </Typography>
                    </OrderListItemDataGroupAStyled>
                </OrderListItemDataGroupStyled>
                <OrderListItemActionMobileStyled>
                    <Button size="large" component={NavLink} to={`/pedido/${ orderNumber(data) }`} sx={{ px: 1, py: 0 }}>
                        <img src={Step2AsStatus3Icon} alt="step-2-status-1" style={{ width: 42}}/>
                    </Button>
                </OrderListItemActionMobileStyled>
            </OrderListItemData>
            <OrderListItemAction>
                <Button size="large" component={NavLink} to={`/pedido/${ orderNumber(data) }`} sx={{ px: 3, py: 0 }}>
                    <img src={Step2AsStatus3Icon} alt="step-2-status-1" style={{ width: 42}}/>
                </Button>
            </OrderListItemAction>
        </OrderListItemRoot>
    )
}

const OrderListItemRoot = styled(Box)(() => ({
    display: 'flex'
}))

const OrderListItemDate = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginRight: theme.spacing(2),
    // [theme.breakpoints.down('md')]: {
    //     display: 'none'
    // }
}))

const ItemDateNumber = styled('span')(({ theme }) => ({
    ...theme.typography.h5,
    lineHeight: 1
}))

const ItemDateMonth = styled('span')(({ theme }) => ({
    ...theme.typography.subtitle2,
    lineHeight: 1,
    textTransform: 'uppercase'
}))

const OrderListItemData = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    padding: theme.spacing(1.5),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(0.5),
    '&:hover': {
        background: theme.palette.grey[100]
    },
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(1),
    }
}))

const OrderListItemDataGroupStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    flex: 1,
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column'
    },
    '& >div:last-child': {
        marging: 0,
        padding: 0,
        border: 'none'
    }
}))

const OrderListItemDataGroupAStyled = styled(Box)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        borderRight: `1px solid ${theme.palette.primary.main}`,
        paddingRight: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    [theme.breakpoints.down('md')]: {
        '&:not(:last-child)': {
            marginBottom: theme.spacing(0.5)
        }
    }
}))

const OrderListItemAction = styled(Box)(({ theme }) => ({
    marginLeft: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
        display: 'none'
    }
}))

const OrderListItemActionMobileStyled = styled(Box)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'none'
    }
}))

export { OrderList, OrderListItem }
